import { IVehicle } from "interfaces/session/IVehicle";
import { trackEvents } from "./trackEvents";

export interface IFitmentPromptedPayload {
  fitmentOptionName: string;
  fitmentOptionTitle: string;
  unselectedFitments: string[];
  selectedFitments: string[];
}

// fitment selected or fitment cleared
export interface IFitmentPayload {
  fitmentOptionName: string;
  fitmentOptionValue: string;
  selectedFitments: string[];
}

export interface IFitmentModalClosedPayload {
  vehicle: IVehicle;
}

export type IFitmentEventPayload = IFitmentPromptedPayload | IFitmentPayload | IFitmentModalClosedPayload;

export function trackFitmentEvent(eventName: string, payload: IFitmentEventPayload) {
  trackEvents(
    eventName,
    "fitment",
    payload,
  );
}
